import { Flex } from 'foundations-components/components/Flex';
import { MultiLevelDropdown } from 'foundations-components/transitional/components/Dropdown';
import { useNavigationMenu } from '../hooks/useNavigationMenu';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { usePortalData } from '../data/usePortalData';
import { Link as RouterLink } from 'react-router-dom';
import I18n from 'I18n';
import { useMemo } from 'react';
import { Text } from 'foundations-components/components/Text';
import { useTheme } from 'foundations-theming/utils';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { usePreviewContext } from '../hooks/usePreviewContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapMenuNodesToDropdownOption = ({
  label,
  children,
  url,
  linkTarget
}, borderRadiusToken, borderRadiusCssValue) => {
  const hasChildren = Array.isArray(children) && children.length > 0;
  const isOpenInNewTab = linkTarget === '_blank';
  const dropdownStyleOverrides = {
    borderRadius: borderRadiusToken,
    '& li button': {
      // Sets border-radius on all menu item buttons
      borderRadius: `${borderRadiusCssValue} !important`,
      // Nested selector for hover/focus states of those buttons
      '&:hover, &:focus, &:focus-visible': {
        borderRadius: `${borderRadiusCssValue} !important`
      }
    }
  };
  return Object.assign({
    label: url ? /*#__PURE__*/_jsx(Link, {
      color: "text-core-default",
      href: url,
      external: isOpenInNewTab,
      target: linkTarget !== null && linkTarget !== void 0 ? linkTarget : undefined,
      children: label
    }) : /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      as: "span",
      children: label
    }),
    options: hasChildren ? children.map(childNode => mapMenuNodesToDropdownOption(childNode, borderRadiusToken, borderRadiusCssValue)) : undefined
  }, hasChildren && {
    // Styles nested submenu containers and items
    dropdownStyles: dropdownStyleOverrides,
    // Styles nested submenu popover wrappers
    popoverProps: {
      borderRadius: borderRadiusToken
    }
  });
};
const mapMenuNodesToDropdownOptions = (nodes, borderRadiusToken, borderRadiusCssValue) => nodes.map(node => mapMenuNodesToDropdownOption(node, borderRadiusToken, borderRadiusCssValue));
export const DesktopNavigationMenu = () => {
  const trellisTheme = useTheme();
  const menuChildren = useNavigationMenu();
  const isUsingPillBorderRadius = useIsPillBorderRadius();
  const {
    suffix: previewSuffix
  } = usePreviewContext();
  const borderRadiusToken = isUsingPillBorderRadius ? '0' : '300';
  const borderRadiusCssValue = isUsingPillBorderRadius ? trellisTheme.borderRadius['0'] : trellisTheme.borderRadius['300'];
  const {
    data
  } = usePortalData();
  const {
    settings
  } = data;
  const dropdownStyleOverrides = {
    borderRadius: borderRadiusToken,
    '& li button': {
      borderRadius: `${borderRadiusCssValue} !important`,
      '&:hover, &:focus, &:focus-visible': {
        borderRadius: `${borderRadiusCssValue} !important`
      }
    }
  };
  const ticketListingsHeading = useMemo(() => {
    return settings.ticketLabelOverride || I18n.text('customer-portal-app.ticketListings.heading.default');
  }, [settings.ticketLabelOverride]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    children: [/*#__PURE__*/_jsx(RouterLink, {
      to: previewSuffix ? `/${previewSuffix}` : '/',
      children: /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-default",
          children: ticketListingsHeading
        })
      })
    }), menuChildren.map(node => {
      var _node$url, _node$linkTarget;
      const isOpenInNewTab = node.linkTarget === '_blank';
      return Array.isArray(node.children) && node.children.length > 0 ? /*#__PURE__*/_jsx(MultiLevelDropdown, {
        buttonText: /*#__PURE__*/_jsx(Text, {
          color: "text-core-default",
          children: node.label
        }),
        buttonUse: "transparent",
        options: mapMenuNodesToDropdownOptions(node.children, borderRadiusToken, borderRadiusCssValue)
        // Styles the dropdown menu container and items (nested CSS via styled-components)
        ,
        dropdownStyles: dropdownStyleOverrides
        // Styles the popover wrapper around the dropdown
        ,
        popoverProps: {
          borderRadius: borderRadiusToken
        }
        // Styles the top-level nav trigger button
        ,
        buttonStyles: {
          borderRadius: borderRadiusToken
        }
      }, node.label) : /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        href: (_node$url = node.url) !== null && _node$url !== void 0 ? _node$url : undefined,
        external: isOpenInNewTab,
        target: (_node$linkTarget = node.linkTarget) !== null && _node$linkTarget !== void 0 ? _node$linkTarget : undefined,
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-default",
          children: node.label
        })
      }, node.label);
    })]
  });
};